import { render, staticRenderFns } from "./contentPage.vue?vue&type=template&id=10578e33&scoped=true"
import script from "./contentPage.vue?vue&type=script&lang=js"
export * from "./contentPage.vue?vue&type=script&lang=js"
import style0 from "./contentPage.vue?vue&type=style&index=0&id=10578e33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10578e33",
  null
  
)

export default component.exports